var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    d: "M10.4,2.126a2,2,0,0,1,3.2,0l2.717,3.613a2,2,0,0,0,.938.686l4.271,1.495a2,2,0,0,1,.985,3.025L19.915,14.7a2,2,0,0,0-.354,1.1l-.091,4.56a2,2,0,0,1-2.583,1.873l-4.3-1.313a2,2,0,0,0-1.167,0l-4.3,1.313a2,2,0,0,1-2.583-1.873L4.44,15.8a2,2,0,0,0-.354-1.1L1.491,10.943a2,2,0,0,1,.985-3.025L6.747,6.424a2,2,0,0,0,.938-.686Z",
    fill: "#feb730"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.1f239c130c8d385c6efcb57b065f5bd6.svg";
export { ForwardRef as ReactComponent };